import React, { ReactNode } from 'react';

import { Link } from 'react-router-dom';

import classes from './navigation-bar.module.scss';

type TNavigationsBarProps = {
  guideArr?: {
    title: string;
    link: string;
  }[];
  children?: ReactNode;
};

export const NavigationBar = ({
  guideArr,
  children,
}: TNavigationsBarProps): JSX.Element => (
  <div className={classes.pointer_guide}>
    <div>
      {guideArr &&
        guideArr.map((item, index) => (
          <Link
            to={item.link}
            className={classes.pointer_guide_link}
            key={`${item}${index}`}
          >
            {item.title}
          </Link>
        ))}
    </div>
    {children && <div className={classes.children_ui_elements}>{children}</div>}
  </div>
);
